import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-deeplink',
  templateUrl: './deeplink.component.html',
  styleUrls: ['./deeplink.component.scss']
})
export class DeeplinkComponent implements OnInit {
  // content: string;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    const contentParam = this.route.snapshot.paramMap.get("content");
    const decodedValue= atob(contentParam);   
    window.location.href = decodedValue;
  }
}
